import * as S from './style';

import { ReactNode } from 'react';

interface GeneralProps {
  children: ReactNode;
}

const General = ({ children }: GeneralProps) => {
  return (
    <S.Wrapper>
      <S.Content>{children}</S.Content>
    </S.Wrapper>
  );
};

export default General;
